import { callsRequests } from '../requests/calls.request';
import { createApiThunk } from '../utils/apiThunk';

export const getCalls = createApiThunk(callsRequests.getCalls);

